import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useLexicalIsTextContentEmpty } from '@lexical/react/useLexicalIsTextContentEmpty';
import { useEffect } from 'react';

import { PlaceholderPluginProps } from './PlaceholderPlugin.types';

export const PlaceholderPlugin = ({ placeholder }: PlaceholderPluginProps) => {
  const [editor] = useLexicalComposerContext();
  const isEmpty = useLexicalIsTextContentEmpty(editor);

  useEffect(() => {
    const rootElement = editor.getRootElement() as HTMLElement;
    if (rootElement) {
      if (isEmpty && placeholder) {
        rootElement.setAttribute('placeholder', placeholder);
      } else {
        rootElement.removeAttribute('placeholder');
      }
    }
  }, [editor, isEmpty, placeholder]);

  return null;
};
